import {
    expose,
    caller as originCaller
} from 'postmsg-rpc';

const SERVER_OPTIONS = {
    postMessage: (msg, targetOrigin) => {
        window.parent?.postMessage(msg, targetOrigin);
    }
};

const CLIENT_OPTIONS = {
    postMessage: (msg, targetOrigin) => {
        window.parent?.postMessage(msg, targetOrigin);
    },
    isCallback: true
};

function callerPostMsg(event, ...props) {
    const localeCaller = originCaller(event, CLIENT_OPTIONS);
    localeCaller(...props);
}

function exposePostMsg(event, handler) {
    expose(event, handler, SERVER_OPTIONS);
}

export {
    callerPostMsg,
    exposePostMsg
};
